import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {CampaignRepository} from "../../../../repositories/CampaignRepository";

// Server-paged phone numbers of a campaign, optionally filtered by status
export const useCampaignPhoneNumbers = (campaignId) => {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [status, setStatus] = useState(null);

  const fetchPhoneNumbers = () => {
    if (!campaignId) return;
    setLoading(true);
    CampaignRepository.getPhoneNumbers(campaignId, {status, page, size: rowsPerPage})
      .then(response => {
        const content = response?.data?.content || [];
        // Page emptied (e.g. its last number was removed) - step back one page
        if (content.length === 0 && page > 0) {
          setPage(page - 1);
          return;
        }
        setRows(content);
        setTotal(response?.data?.totalElements || 0);
      })
      .catch(error => {
        console.error(error);
        toast.error("Failed to load phone numbers");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPhoneNumbers();
  }, [campaignId, status, page, rowsPerPage]);

  return {
    rows,
    total,
    loading,
    page,
    rowsPerPage,
    status,
    setPage,
    setRowsPerPage: (size) => {
      setRowsPerPage(size);
      setPage(0);
    },
    setStatus: (value) => {
      setStatus(value);
      setPage(0);
    },
    refresh: fetchPhoneNumbers,
  };
};
